export default __webpack_public_path__ + "static/celaya-labelbadge-07-90093bf338680b991dee1ebe6914bb8d.png";